import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getHRMDetails } from '../../API/API'

function* getHRMDetailsSaga(params) {
    try {
        const response = yield call(() => getHRMDetails(params.payload)); 
        yield put({type: types.HRM_DETAILS_SUCCESS, payload: response.data});
      }
      catch (error) {
        yield put({type: types.HRM_DETAILS_FAILURE, error});
    }
}

export function* watchHRMDetailsSaga() {
    yield takeEvery(types.HRM_DETAILS_INIT, getHRMDetailsSaga);
}